import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import DashboardDateRangeFilter from '../dashboard/DashboardDateRangeFilter';

const STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'completed', label: 'Completed' },
  { value: 'revoked', label: 'Revoked' },
];

const TeamDashboardFilters = ({
  dateRange,
  onDateRangeChange,
  filters,
  onFiltersChange,
  orgUsers = [],
  disabled = false,
}) => {
  const [draft, setDraft] = React.useState(filters);

  React.useEffect(() => {
    setDraft(filters);
  }, [filters]);

  const handleApply = () => {
    onFiltersChange(draft);
  };

  const handleReset = () => {
    const cleared = {
      created_by_user_id: '',
      status: '',
      recipient_email: '',
      template_id: '',
    };
    setDraft(cleared);
    onFiltersChange(cleared);
  };

  return (
    <div className="team-dashboard-filters">
      <DashboardDateRangeFilter
        value={dateRange}
        onChange={onDateRangeChange}
        disabled={disabled}
      />
      <Row className="g-2 align-items-end mt-3">
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label className="small text-muted mb-1">Created by</Form.Label>
            <Form.Select
              size="sm"
              value={draft.created_by_user_id}
              disabled={disabled}
              onChange={(e) => setDraft((prev) => ({ ...prev, created_by_user_id: e.target.value }))}
            >
              <option value="">All users</option>
              {orgUsers.map((member) => {
                const id = member.id ?? member.user_id;
                const label = member.name || member.email || `User ${id}`;
                return (
                  <option key={id} value={id}>
                    {label}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={2}>
          <Form.Group>
            <Form.Label className="small text-muted mb-1">Status</Form.Label>
            <Form.Select
              size="sm"
              value={draft.status}
              disabled={disabled}
              onChange={(e) => setDraft((prev) => ({ ...prev, status: e.target.value }))}
            >
              {STATUS_OPTIONS.map((opt) => (
                <option key={opt.value || 'all'} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label className="small text-muted mb-1">Recipient email</Form.Label>
            <Form.Control
              size="sm"
              type="search"
              placeholder="Search recipient"
              value={draft.recipient_email}
              disabled={disabled}
              onChange={(e) => setDraft((prev) => ({ ...prev, recipient_email: e.target.value }))}
            />
          </Form.Group>
        </Col>
        <Col xs={6} md="auto">
          <Button size="sm" variant="primary" disabled={disabled} onClick={handleApply}>
            Apply filters
          </Button>
        </Col>
        <Col xs={6} md="auto">
          <Button size="sm" variant="outline-secondary" disabled={disabled} onClick={handleReset}>
            Reset
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default TeamDashboardFilters;
